import React from 'react';
import { Link } from 'react-router-dom';
import { formatArchiveDate } from './BriefingDateNav';

const Card = ({ emoji, emojiClass = '', title, children }) => (
  <div className="card-clay-static p-12 text-center">
    <div className={`text-6xl mb-4 ${emojiClass}`}>{emoji}</div>
    <h2 className="font-display text-2xl font-bold text-heading mb-2">{title}</h2>
    {children}
  </div>
);

export const ArchiveMissingCard = ({ archiveDate }) => (
  <Card emoji="🗓️" title="No briefing for this date">
    <p className="text-secondary-text mb-6 max-w-md mx-auto">
      There is no briefing for {formatArchiveDate(archiveDate)}.
    </p>
    <Link to="/daily" className="btn-clay inline-flex items-center">
      Back to today
    </Link>
  </Card>
);

// Reason: the dates index and the briefing payloads are cached separately, so
// offline the index can advertise a date that was never downloaded. Discovery is
// a catalogue, not an availability guarantee — say which it is instead of
// rendering an error or a blank page (§3.6).
export const ArchiveNotDownloadedCard = ({ archiveDate }) => (
  <Card emoji="📥" title="Not downloaded">
    <p className="text-secondary-text mb-6 max-w-md mx-auto">
      {formatArchiveDate(archiveDate)} is in your archive list, but its briefing
      was never saved to this device. Reconnect to read it.
    </p>
    <Link to="/daily" className="btn-clay inline-flex items-center">
      Back to today
    </Link>
  </Card>
);

export const NoBriefingYetCard = ({ generating, onGenerate }) => (
  <Card emoji="☀️" emojiClass="animate-bounce-gentle" title="No briefing yet">
    <p className="text-secondary-text mb-6 max-w-md mx-auto">
      Generate a daily briefing to get a curated overview of news from Hacker News, GitHub trending, and web sources.
    </p>
    <button
      onClick={onGenerate}
      disabled={generating}
      className="btn-clay inline-flex items-center"
    >
      {generating ? 'Generating...' : 'Generate Briefing'}
    </button>
  </Card>
);
